/************************* CONSTANTS *************************/
const modalQuoter = document.querySelector(".modal-download");
const openQuoterModalBtn = document.querySelector("#open-quoter-modal-btn");
const closeModalButton = document.querySelector(".close-button");
const quoterForm = document.querySelector("#modal-quoter-form");

function getQuoterSku() {
  const el = document.getElementById('ProductJson');
  const variantInput = document.querySelector('.mlc-pdp .product-form input[name="id"]');
  try {
    const product = JSON.parse(el?.textContent || '{}');
    const selected = product.variants?.find(v => String(v.id) === String(variantInput?.value));
    const sku = selected?.sku || document.getElementById('product_sku')?.textContent?.trim();
    return Number(sku) || 0;
  } catch (error) {
    return Number(document.getElementById('product_sku')?.textContent?.trim()) || 0;
  }
}

const sendQuoterBtn = document.querySelector("#send-quoter-btn");
const spanLoader = document.querySelector("#button-loader");
const successMessage = document.querySelector("#success-message-quoter");
/************************* FUNCTIONS *************************/

function toggleModal(e) {
  e.preventDefault();
  modalQuoter.classList.toggle("show-modal");
}

function windowOnClick(event) {
  if (event.target === modalQuoter) {
    toggleModal();
  }
}

async function sendQuoter(e) {
  try {
    e.preventDefault();

    sendQuoterBtn.disabled = true;
    spanLoader.style.display = "inline-block";

    // console.log(sku);
    const formData = new FormData(e.target);
    const quoterData = {
      sku: getQuoterSku(),
      is_moleculab : true
    };
    formData.forEach((value, key) => {
      quoterData[key] = value;
    });

    // console.log(quoterData);

    const emailResponse = await fetch(
      "https://sfc2akxvwaaxslp7iknupzh5ua0itbyj.lambda-url.us-east-1.on.aws/api/quoter",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(quoterData),
      }
    );

    const emailResult = await emailResponse.json();
    if (!emailResponse.ok || (emailResult && (emailResult.success === false || emailResult.error))) {
      throw new Error('La solicitud no fue aceptada por el servidor');
    }

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('mlc:quote_request_submitted', {
        page_type: 'product',
        source: 'product_quote_form',
        sku: String(quoterData.sku || '')
      });
    }

    sendQuoterBtn.disabled = false;
    spanLoader.style.display = "none";
    successMessage.style.display = "inline-block";
    quoterForm.reset();
  } catch (error) {
    // console.log(error);
    sendQuoterBtn.disabled = false;
    spanLoader.setAttribute("style", "display: none;");
    let errorText = quoterForm.querySelector('#mlc-quoter-error');
    if (!errorText) {
      errorText = document.createElement('p');
      errorText.id = 'mlc-quoter-error';
      errorText.setAttribute('role', 'alert');
      errorText.style.color = '#a52d2d';
      errorText.style.marginTop = '12px';
      quoterForm.appendChild(errorText);
    }
    errorText.textContent = 'No pudimos enviar la solicitud. Verifica tu conexión e intenta nuevamente.';
  }
}

/************************* LISTENERS *************************/
if (modalQuoter && openQuoterModalBtn && closeModalButton) {
  // document.addEventListener("DOMContentLoaded", processDescription);
  openQuoterModalBtn.addEventListener("click", toggleModal);
  closeModalButton.addEventListener("click", toggleModal);
  window.addEventListener("click", windowOnClick);
  quoterForm.addEventListener("submit", sendQuoter);
}